import React, { useEffect, useRef, useState } from 'react'
import './chat-item.styles.scss'

import { format, set } from 'date-fns'
import { useDispatch, useSelector } from 'react-redux'
import { setUnread } from '@/state/slices/gameSlice'
import { UseCloudFunction } from '@/firebase-utils/firebase.utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamation, faExclamationCircle, faMagnifyingGlass, faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import pro from '@/assets/pro.png';
import heart from '@/assets/heart.png';
import laugh from '@/assets/laugh.png';
import angry from '@/assets/angry.png';
import Linkify from 'linkify-react'
import EmojiViewModal from './emoji-view-modal.component'

const ChatItem = ({
  mess,
  icon,
  setChatToView,
  setReplyId,
  replyButton,
  isReply,
  leaders
}) => {

  let unread = { ...useSelector(state => state.gameData.unread) };
  const currentGame = useSelector(state => state.gameData.currentGame);
  const userProfile = useSelector(state => state.userData.profile);
  const [linkifyOptions] = useState({ 'target': '_blank' });
  const [unreadReplies, setUnreadReplies] = useState(0);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [ showEmojiView, setShowEmojiView ] = useState(null);
  const messRef = useRef();
  const unreadRef = useRef({ ...unread });
  const dispatch = useDispatch();

  useEffect(() => {
    console.log('showEmojiView changed', showEmojiView, mess);
  }, [showEmojiView])

  useEffect(() => {
    if (!mess) return;
    messRef.current = { ...mess };
    setSelectedMessage(messRef.current);
  }, [mess])

  useEffect(() => {
    if (!unread || !mess) return;
    delete unread.status;
    let replyCount = 0;
    for (let u of Object.values(unread)) {
      if (mess.replies && mess.replies[u.id]) {
        replyCount++;
      }
    }
    setUnreadReplies(replyCount);
  }, [unread, selectedMessage])

  function openChat() {
    setChatToView(mess)
    setReplyId(mess.id)
  }

  async function removeUnread(id) {
    let tempUnread = { ...unreadRef.current };
    delete tempUnread[id]
    unreadRef.current = { ...tempUnread }
    dispatch(setUnread({ ...unreadRef.current }))
    const res = await UseCloudFunction('removeUnread', { 'noteId': id, 'gameId': currentGame.gameId, 'appId': userProfile.appId })
    console.log(res)
  }

  async function toggleEmoji(type, chatId, replyId) {
    const now = new Date().getTime();
    let tempMess = { ...messRef.current };
    if (tempMess[type]) {
      if (tempMess[type][userProfile.appId]) {
        delete tempMess[type][userProfile.appId]
      } else {
        tempMess[type][userProfile.appId] = now;
      }
    } else {
      tempMess[type] = {
        [userProfile.appId]: now
      }
    }
    messRef.current = { ...tempMess };
    setSelectedMessage(messRef.current);
    console.log(chatId)
    const res = await UseCloudFunction('toggleEmoji', {
      'appId': userProfile.appId,
      'chatId': chatId,
      'replyId': replyId || null,
      'type': type,
    })
    console.log(res)
  }

  if (selectedMessage && !selectedMessage.original) {
    return (
      <div
        className={`chat-item ${unread && unread[selectedMessage.id] ? 'jello-horizontal' : ''}`}
        id={selectedMessage.id}
        onClick={() => (unread && unread[selectedMessage.id]) ? removeUnread(selectedMessage.id) : null} >
        {
          <div key={selectedMessage.ts} className={`chat-bubble ${unread && unread[selectedMessage.id] ? 'unread' : ''}`}>
            <div className='chat-head'>
              <img src={icon} className='chat-icon' />
              <div className='chat-head-text'>
                <div className='chat-content'>{selectedMessage.name}</div>
                <div className='chat-date'>{format(new Date(selectedMessage.ts), 'Pp')}</div>
              </div>
            </div>
            <div className="chat-text">
              {/* {selectedMessage.ts} {selectedMessage.latest} */}
              <div className='chat-content'>
                <Linkify options={linkifyOptions}>
                  {selectedMessage.text}
                </Linkify>
              </div>
              {
                (selectedMessage.image) &&
                <div data-uk-lightbox='animation:fade'>
                  <a href={selectedMessage.image}>
                    <img src={selectedMessage.image} className={`chat-image ${!replyButton && 'reply'}`} alt='chat upload' loading='lazy' />
                  </a>
                </div>

              }

              {
                // (!isReply) &&
                <div className='comment-like' >
                  <div className='emoji-row'>
                    {/* NOTE: in data, selectedMessage.replyId is actually the original chat id */}
                    <div
                      className='like-button-div'
                      onClick={() => toggleEmoji(
                        'likes', 
                        selectedMessage.replyId, 
                        selectedMessage.id
                      )}
                    >
                      <img 
                        src={pro} 
                        style={{ 'height': '1em' }} /> {
                          selectedMessage.likes 
                          ? Object.keys(selectedMessage.likes).length 
                          : '0'
                        }
                    </div>
                    <div className='like-button-div' onClick={() => toggleEmoji('loves', selectedMessage.replyId, selectedMessage.id)}>
                      <img src={heart} style={{ 'height': '1em' }} /> {selectedMessage.loves ? Object.keys(selectedMessage.loves).length : '0'}
                    </div>
                    <div className='like-button-div' onClick={() => toggleEmoji('laughs', selectedMessage.replyId, selectedMessage.id)}>
                      <img src={laugh} style={{ 'height': '1em' }} /> {selectedMessage.laughs ? Object.keys(selectedMessage.laughs).length : '0'}
                    </div>
                    <div className='like-button-div' onClick={() => toggleEmoji('angries', selectedMessage.replyId, selectedMessage.id)}>
                      <img src={angry} style={{ 'height': '1em' }} /> {selectedMessage.angries ? Object.keys(selectedMessage.angries).length : '0'}
                    </div>
                    <div className='like-button-div emoji-view' onClick={() => setShowEmojiView(selectedMessage.id)}>
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        {
          (showEmojiView && selectedMessage) &&
          <EmojiViewModal
            show={showEmojiView}
            cancel={() => setShowEmojiView(null)}
            leaders={leaders}
            message={selectedMessage} />
        }
      </div>
    )
  } else if (selectedMessage) {
    return (
      <div className={`chat-item ${unread && unread[selectedMessage.id] ? 'jello-horizontal' : ''}`} id={selectedMessage.id} onClick={() => (unread && unread[selectedMessage.id]) ? removeUnread(selectedMessage.id) : null} >
        {
          <div key={selectedMessage.ts} className={`chat-bubble ${unread && unread[selectedMessage.id] ? 'unread' : ''}`}>
            <div className='chat-head'>
              <img src={icon} className='chat-icon' />
              <div className='chat-head-text'>
                <div className='chat-content'>{selectedMessage.name}</div>
                <div className='chat-date'>{format(new Date(selectedMessage.ts_posted), 'Pp')}</div>
              </div>
            </div>
            <div className="chat-text">
              {/* {selectedMessage.ts} {selectedMessage.latest} */}
              <div className='chat-content'>{selectedMessage.text}</div>  {/* {selectedMessage.text.length > 45 ? `${selectedMessage.text.substring(0, 45)}...` : selectedMessage.text} {selectedMessage.text.length > 25 && <a onClick={() => openChat()}>more</a>}*/}
              {
                (selectedMessage.image) &&
                <div data-uk-lightbox='animation:fade'>
                  <a href={selectedMessage.image}>
                    <img src={selectedMessage.image} className={`chat-image ${!replyButton && 'reply'}`} alt='upload' loading='lazy' />
                  </a>
                </div>
              }

              <div className='comment-like' >
                <div className='emoji-row'>
                  <div className='like-button-div' onClick={() => toggleEmoji('likes', selectedMessage.id)}>
                    <img src={pro} /> {selectedMessage.likes ? Object.keys(selectedMessage.likes).length : '0'}
                  </div>
                  <div className='like-button-div' onClick={() => toggleEmoji('loves', selectedMessage.id)}>
                    <img src={heart} /> {selectedMessage.loves ? Object.keys(selectedMessage.loves).length : '0'}
                  </div>
                  <div className='like-button-div' onClick={() => toggleEmoji('laughs', selectedMessage.id)}>
                    <img src={laugh} /> {selectedMessage.laughs ? Object.keys(selectedMessage.laughs).length : '0'}
                  </div>
                  <div className='like-button-div' onClick={() => toggleEmoji('angries', selectedMessage.id)}>
                    <img src={angry} /> {selectedMessage.angries ? Object.keys(selectedMessage.angries).length : '0'}
                  </div>
                  <div className='like-button-div emoji-view' onClick={() => setShowEmojiView(selectedMessage.id)}>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </div>
                </div>
                {
                  (!isReply) &&
                  <>

                    <div className='reply-button' onClick={() => openChat()}>
                      {
                        (selectedMessage.replies)
                          ?
                          <div className='reply-div'>
                            {
                              (unreadReplies > 0) &&
                              <div className='new-reply'>
                                {unreadReplies}
                              </div>
                            }
                            <div>
                              {
                                (Object.keys(selectedMessage.replies).length > 1)
                                  ?
                                  `${Object.keys(selectedMessage.replies).length} Replies`
                                  :
                                  `${Object.keys(selectedMessage.replies).length} Reply`
                              }
                            </div>
                          </div>
                          :
                          'Reply'
                      }
                    </div>
                  </>
                }


              </div>

              {/* {
                                mess.replies &&
                                Object.values(mess.replies).sort((a,b) => a.ts < b.ts ? 1 : -1)
                                .map(reply => (
                                    <div className='chat-bubble reply'>
                                        <img src={reply.icon} className='chat-icon' />
                                    </div>
                                ))
                                
                            } */}
            </div>
          </div>
        }
        {
          (showEmojiView && selectedMessage) &&
          <EmojiViewModal
            show={showEmojiView}
            cancel={() => setShowEmojiView(null)}
            leaders={leaders}
            message={selectedMessage} />
        }
      </div>
    )
  }
}

export default ChatItem;